<template>
  <v-layout>
    <v-chip
      class="ma-2"
      v-if="status === statusINTERESTED"
      close
      small
      color="success"
      text-color="white"
      close-icon="mdi-check"
    >Interested</v-chip>
    <v-chip
      class="ma-2"
      v-if="status === statusNOTINTERESTED"
      close
      small
      color="red"
      text-color="white"
      close-icon="mdi-cancel"
    >Not Interested</v-chip>
    <v-chip
      class="ma-2"
      v-if="status === statusINVITED"
      close
      small
      color="primary"
      text-color="white"
      close-icon="mdi-account-clock"
    >Pending</v-chip>
    <v-chip
      class="ma-2"
      v-if="status === statusACCEPTED && (isAgree === null || isAgree === undefined)"
      close
      small
      color="success"
      text-color="white"
      close-icon="mdi-check"
    >Accepted</v-chip>
    <v-chip
      class="ma-2"
      v-if="status === statusNOTACCEPTED"
      close
      small
      color="red"
      text-color="white"
      close-icon="mdi-cancel"
    >Not Accepted</v-chip>
    <v-chip
      class="ma-2"
      v-if="status === statusINQUIRY"
      close
      small
      color="info"
      text-color="white"
      close-icon="mdi-account-clock"
    >Inquiry</v-chip> 
    <v-chip
      class="ma-2"
      v-if="status === statusELIMINATION_PENDING"
      close
      small
      color="primary"
      text-color="white"
      close-icon="mdi-account-clock"
    >Not Invited</v-chip>
    <v-chip
      class="ma-2"
      v-if="status === statusACCEPTED && isAgree === false"
      close
      small
      color="red"
      text-color="white"
      close-icon="mdi-cancel"
    >Declined</v-chip>
    <v-chip
      class="ma-2"
      v-if="status === statusACCEPTED && isAgree === true"
      close
      small
      color="success"
      text-color="white"
      close-icon="mdi-check"
    >Agreed</v-chip>    
  </v-layout>
</template>
<script>
// import campaignConfigs from '../../views/Campaign/config';
import { mapGetters } from 'vuex'
export default {
  name: 'PairingStatus',
  props: {
    status: Boolean,
    isAgree: Boolean
  },
  computed: {
    ...mapGetters('pairing', {
      pairingStatus: 'status'
    }),
    statusINVITED() {
      // return campaignConfigs.pairingStatus.INVITED;
      return this.pairingStatus.INVITED.value;
    },
    statusINTERESTED() {
      // return campaignConfigs.pairingStatus.ACCEPT;
      return this.pairingStatus.INTERESTED.value;
    },
    statusNOTINTERESTED() {
      // return campaignConfigs.pairingStatus.REJECT;
      return this.pairingStatus.NOT_INTERESTED.value;
    },
    statusACCEPTED() {
      // return campaignConfigs.pairingStatus.ACCEPT;
      return this.pairingStatus.ACCEPTED.value;
    },
    statusNOTACCEPTED() {
      // return campaignConfigs.pairingStatus.ACCEPT;
      return this.pairingStatus.NOT_ACCEPTED.value;
    },
    statusINQUIRY() {
      // return campaignConfigs.pairingStatus.ACCEPT;
      return this.pairingStatus.INQUIRY.value;
    },
    statusELIMINATION_PENDING() {
      // return campaignConfigs.pairingStatus.ACCEPT;
      return this.pairingStatus.ELIMINATION_PENDING.value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// PairingStatus.vue?067a679c